import D2AAnnualGrowthTable from './D2AAnnualGrowthTable.container';
export default D2AAnnualGrowthTable;
